import { css } from "emotion";
import ColorServices from "../../services/ColorServices";
import { max } from "../../utils/CssUtils";

const sizes = {
  large: {
    cursor: "pointer",
    borderRadius: 4,
    height: 40,
    textAlign: "center",
    fontSize: 16,
    fontWeight: 600,
    padding: "0 24px",
    [max(600)]: {
      textAlign: "center",
      height: 36,
      fontSize: 14,
      padding: "0px 24px"
    }
  },

  medium: {
    cursor: "pointer",
    borderRadius: 4,
    height: 36,
    textAlign: "center",
    fontSize: 14,
    padding: "0px 24px",
    fontWeight: 600,
    [max(600)]: {
      height: 32
    }
  },

  small: {
    cursor: "pointer",
    borderRadius: 4,
    height: 32,
    padding: "0px 24px",
    fontSize: 14,
    fontWeight: 600
  },

  wide: {
    cursor: "pointer",
    borderRadius: 4,
    height: 36,
    padding: "0px 24px",
    fontSize: 14,
    fontWeight: 600,
    width: "100%"
  }
};

const types = {
  primary: {
    full: {
      border: `${ColorServices.getColor("purple")} 1px solid`,
      backgroundColor: ColorServices.getColor("purple"),
      color: ColorServices.getColor("white"),
      "&:hover": {
        border: `${ColorServices.getColor("purpleMid")} 1px solid`,
        backgroundColor: ColorServices.getColor("purpleMid"),
        color: ColorServices.getColor("white")
      }
    },
    hollow: {
      border: `${ColorServices.getColor("purple")} 1px solid`,
      backgroundColor: ColorServices.getColor("transparent"),
      color: ColorServices.getColor("purple"),
      "&:hover": {
        border: `${ColorServices.getColor("purple")} 1px solid`,
        backgroundColor: ColorServices.getColor("purple"),
        color: ColorServices.getColor("white")
      }
    }
  },
  secondary: {
    full: {
      border: `${ColorServices.getColor("turquoise")} 1px solid`,
      backgroundColor: ColorServices.getColor("turquoise"),
      color: ColorServices.getColor("purpleMid"),
      "&:hover": {
        border: `${ColorServices.getColor("turquoiseMid")} 1px solid`,
        backgroundColor: ColorServices.getColor("turquoiseMid"),
        color: ColorServices.getColor("purpleMid")
      }
    },
    hollow: {
      border: `${ColorServices.getColor("turquoise")} 1px solid`,
      backgroundColor: ColorServices.getColor("transparent"),
      color: ColorServices.getColor("turquoise"),
      "&:hover": {
        border: `${ColorServices.getColor("turquoise")} 1px solid`,
        backgroundColor: ColorServices.getColor("turquoise"),
        color: ColorServices.getColor("purpleMid")
      }
    }
  }
};

const Button = ({
  size = "medium",
  type = "primary",
  style = "full",
  link,
  onClick,
  children,
  ariaLabel
}) => {
  const styles = css({
    ...sizes[size],
    ...types[type][style]
  });

  if (link) {
    return (
      <a href={link} aria-label={ariaLabel}>
        <button
          onClick={onClick}
          className={styles}
          aria-hidden={true}
          tabIndex="-1"
        >
          {children}
        </button>
      </a>
    );
  }
  return (
    <button onClick={onClick} className={styles} aria-label={ariaLabel}>
      {children}
    </button>
  );
};

export default Button;
